// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg .group[data-v-71444ba8]{transform-origin:center}@keyframes spin-71444ba8{to{transform:rotate(1turn)}}.svg .group[data-v-71444ba8]{animation:spin-71444ba8 15s linear infinite}.svg:hover .group[data-v-71444ba8]{animation-play-state:paused}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
